import "../styles/globals.css";
import "../styles/fonts_css/merriweather.css";
import "../styles/fonts_css/lato.css";
import "../styles/fonts_css/paulaner_1634.css";
import "../styles/local-components/header.scss";
import "../styles/local-components/footer.scss";
import "../styles/local-components/agecheck.scss";
import "../styles/components/moodbanner.scss";
import "../styles/components/ImgTextSlider.scss";
import "../styles/components/NLModule.scss";
import "../styles/components/ContactPartner.scss";
import "../styles/components/ContactPartnerWOForm.scss";
import "../styles/components/ImgText.scss";
import "../styles/components/FindObjectMap.scss";
import "../styles/components/FAQ.scss";
import "../styles/subpages/markenundbiere.scss";
import "../styles/components/Headinfo.scss";
import "../styles/components/subpages-technik/Schankdruckrechner.scss";
import "../styles/components/subpages-footer/contact.scss";
import "../styles/components/MoodBannerWrap.scss";
import "../styles/components/InfotextImage.scss";
import "../styles/components/IntroLogo.scss";
import "../styles/components/ImageInfotext.scss";
import "../styles/components/SingleImageBig.scss";
import "../styles/components/RichText.scss";
import "../styles/components/SingleImageSmall.scss";
import "../styles/components/TextWithSections.scss";
import "../styles/components/ImageFullWidth.scss";
import "../styles/components/MoodBannerVideo.scss";
import "../styles/local-components/error.scss";
import "../styles/components/TextWithButton.scss";
import "../styles/components/TextWithButtonIntro.scss";
import "../styles/components/ImgTextArticle.scss";
import "../styles/components/ImgTextLeft.scss";
import "../styles/components/IconsWithButton.scss";
import "../styles/components/TextWithContact.scss";
import "../styles/components/ImgTextButton.scss";
import "../styles/components/BrandsLogos.scss";
/* subpages-brands */
import "../styles/components/subpages-brands/BrandsHeader.scss";
import "../styles/components/subpages-brands/BrandsImgText.scss";
import "../styles/components/subpages-brands/ImageSlider.scss";
import "../styles/components/subpages-brands/BrandsOverview.scss";
import "../styles/components/subpages-brands/ProductSlider.scss";
import "../styles/components/subpages-brands/ProductSliderWrap.scss";
import "../styles/components/subpages-brands/InstagramSlider.scss";
import "../styles/components/subpages-brands/BrandsLogoSlider.scss";
import "../styles/components/subpages-brands/SoloImg.scss";
import "../styles/components/subpages-brands/BrandsHeaderBigLogos.scss";
import "../styles/components/subpages-brands/HeadlineAndButton.scss";
/* subpages-service-seminare */
import "../styles/components/subpages-service-seminare/ServiceHeadinfo.scss";
import "../styles/components/subpages-service-seminare/ServiceSlider.scss";
import "../styles/components/subpages-service-seminare/ServiceContactPerson.scss";
import "../styles/components/subpages-service-seminare/SeminarangebotOffering.scss";
import "../styles/components/subpages-service-seminare/ServiceMysterycheck.scss";
import "../styles/components/subpages-service-seminare/Seminarangebot.scss";
import "../styles/components/subpages-service-seminare/ServiceMap.scss";
import "../styles/components/subpages-technik/TextImage.scss";
import "../styles/components/subpages-service-seminare/ServiceShortText.scss";
import "../styles/components/subpages-service-seminare/ServiceSingleButton.scss";
import "../styles/components/subpages-service-seminare/ServiceTextSmallImage.scss";
import "../styles/components/subpages-service-seminare/SeminarTextColumn.scss";
import "../styles/components/subpages-service-seminare/ServiceSubheadline.scss";
import "../styles/components/subpages-service-seminare/ServiceImgText.scss";
import "../styles/components/subpages-service-seminare/TextButtonImage.scss";
import "../styles/components/subpages-service-seminare/ServiceTextFiftyFifty.scss";
import "../styles/components/subpages-service-seminare/ServiceBigTextOnly.scss";
import "../styles/components/subpages-service-seminare/ServiceSingleButtonSmaller.scss";
import "../styles/components/subpages-service-seminare/GastroforumBigPicture.scss";
import "../styles/components/subpages-service-seminare/SeminarHeadlineAndButton.scss";
import "../styles/local-components/CookieConsent.scss";
/* subpages-technik */
import "../styles/components/subpages-technik/SchanktechnikContent.scss";
import "../styles/components/subpages-technik/TextImageSmaller.scss";
/* subpages-footer */
import "../styles/components/subpages-footer/headlinewithtext.scss";
import "../styles/components/subpages-footer/headlinewithrichtext.scss";
import "../styles/components/subpages-footer/headlinefooter.scss";
import "../styles/components/subpages-footer/singletext.scss";
/* import "../styles/components/subpages-footer/cookielayerlink.scss"; */

import { storyblokInit, apiPlugin } from "@storyblok/react";
import Feature from "../components/existingstoryblok/Feature";
import Grid from "../components/existingstoryblok/Grid";
import Page from "../components/existingstoryblok/Page";
import Teaser from "../components/existingstoryblok/Teaser";
import Header from "../local_components/Header";
import AgeCheck from "../local_components/AgeCkeck";
import MoodBanner from "../components/MoodBanner";
import MoodBannerWrap from "../components/MoodBannerWrap";
import MoodBannerVideo from "../components/MoodBannerVideo";
import ImgTextSlider from "../components/ImgTextSlider";
import NLModule from "../components/NLModule";
import ContactPartner from "../components/ContactPartner";
import ContactPartnerWOForm from "../components/ContactPartnerWOForm";
import ImgText from "../components/ImgText";
import FindObjectMap from "../components/FindObjectMap";
import FAQ from "../components/FAQ";
import Headinfo from "../components/Headinfo";
import BrandsHeader from "../components/subpages-brands/BrandsHeader";
import BrandsImgText from "../components/subpages-brands/BrandsImgText";
import ImageSlider from "../components/subpages-brands/ImageSlider";
import BrandsOverview from "../components/subpages-brands/BrandsOverview";
import ProductSlider from "../components/subpages-brands/ProductSlider";
import ServiceHeadinfo from "../components/subpages-service-seminare/ServiceHeadinfo";
import ServiceShortText from "../components/subpages-service-seminare/ServiceShortText";
import ServiceSlider from "../components/subpages-service-seminare/ServiceSlider";
import Schankdruckrechner from "../components/subpages-technik/Schankdruckrechner";
import ServiceMap from "../components/subpages-service-seminare/ServiceMap";
import ServiceContactPerson from "../components/subpages-service-seminare/ServiceContactPerson";
import ServiceSingleButton from "../components/subpages-service-seminare/ServiceSingleButton";
import ServiceMysterycheck from "../components/subpages-service-seminare/ServiceMysterycheck";
import Seminarangebot from "../components/subpages-service-seminare/Seminarangebot";
import SeminarangebotOffering from "../components/subpages-service-seminare/SeminarangebotOffering";
import ProductSliderWrap from "../components/subpages-brands/ProductSliderWrap";
import ListItem from "../components/subpages-brands/ListItem";
import Item from "../components/subpages-brands/Item";
import ImageSliderWrap from "../components/subpages-brands/ImageSliderWrap";
import FAQWrap from "../components/FAQWrap";
import InstagramSliderWrap from "../components/subpages-brands/InstagramSliderWrap";
import InstagramSlider from "../components/subpages-brands/InstagramSlider";
import SoloImage from "../components/subpages-brands/SoloImage";
import TextImage from "../components/subpages-technik/TextImage";
import BrandsLogoSlider from "../components/subpages-brands/BrandsLogoSlider";
import InfotextImage from "../components/InfotextImage";
import IntroLogo from "../components/IntroLogo";
import ImageInfotext from "../components/ImageInfotext";
import RichText from "../components/RichText";
import SingleImageBig from "../components/SingleImageBig";
import SingleImageSmall from "../components/SingleImageSmall";
import SchanktechnikContent from "../components/subpages-technik/SchanktechnikContent";
import ServiceTextSmallImage from "../components/subpages-service-seminare/ServiceTextSmallImage";
import SeminarTextColumn from "../components/subpages-service-seminare/SeminarTextColumn";
import ServiceSubheadline from "../components/subpages-service-seminare/ServiceSubheadline";
import ServiceImgText from "../components/subpages-service-seminare/ServiceImgText";
import TextWithSections from "../components/TextWithSections";
import ImageFullWidth from "../components/ImageFullWidth";
import TextButtonImage from "../components/subpages-service-seminare/TextButtonImage";
import ServiceTextFiftyFifty from "../components/subpages-service-seminare/ServiceTextFiftyFifty";
import ServiceBigTextOnly from "../components/subpages-service-seminare/ServiceBigTextOnly";
import BrandsHeaderBigLogos from "../components/subpages-brands/BrandsHeaderBigLogos";
import TextImageSmaller from "../components/subpages-technik/TextImageSmaller";
import GastroforumBigPicture from "../components/subpages-service-seminare/GastroforumBigPicture";
import ServiceSingleButtonSmaller from "../components/subpages-service-seminare/ServiceSingleButtonSmaller";
import HeadlineAndButton from "../components/subpages-brands/HeadlineAndButton";
import SeminarHeadlineAndButton from "../components/subpages-service-seminare/SeminarHeadlineAndButton";
import TextWithButton from "../components/TextWithButton";
import TextWithButtonIntro from "../components/TextWithButtonIntro";
import ImgTextArticle from "../components/ImgTextArticle";
import ImgTextLeft from "../components/ImageTextLeft";
import IconsWithButton from "../components/IconsWithButton";
import TextWithContact from "../components/TextWithContact";
import ImgTextButton from "../components/ImgTextButton";
import BrandsLogos from "../components/BrandsLogos";
/* Brandsheader-files-js */
import BrandsHeaderHacker from "../components/subpages-brands/brandsheader-files/BrandsHeaderHacker";
import BrandsHeaderHopf from "../components/subpages-brands/brandsheader-files/BrandsHeaderHopf";
import BrandsHeaderPaulaner from "../components/subpages-brands/brandsheader-files/BrandsHeaderPaulaner";
/* Brandsheader-files-scss */
import "../styles/components/subpages-brands/brandheader-files/BrandsHeaderHacker.scss";
import "../styles/components/subpages-brands/brandheader-files/BrandsHeaderPaulaner.scss";
import "../styles/components/subpages-brands/brandheader-files/BrandsHeaderHopf.scss";
/* subpages-footer */
import Contact from "../components/subpages-footer/Contact";
import HeadlineWithText from "../components/subpages-footer/HeadlineWithtext";
import HeadlineWithRichtext from "../components/subpages-footer/HeadlineWithRichtext";
import HeadlineFooter from "../components/subpages-footer/HeadlineFooter";
import SingleText from "../components/subpages-footer/SingleText";
import CookieLayerLink from "../components/subpages-footer/CookieLayerLink";

/* react/next */

import { useRouter } from "next/router";
import Head from "next/head";
import Script from "next/script";
import React, { useState, useEffect } from "react";
import CookieConsent from "../local_components/CookieConsent";
import { CookiesProvider, useCookies } from "react-cookie";
//import ReactGA from "react-ga";
import { Cookies } from "react-cookie";
import { Router } from "next/router";

const components = {
  feature: Feature,
  grid: Grid,
  teaser: Teaser,
  page: Page,
  header: Header,
  agecheck: AgeCheck,
  moodbanner: MoodBanner,
  moodbannerwrap: MoodBannerWrap,
  moodbannervideo: MoodBannerVideo,
  imgtextslider: ImgTextSlider,
  newsletter: NLModule,
  contactpartner: ContactPartner,
  contactpartnerwoform: ContactPartnerWOForm,
  imagetext: ImgText,
  findobjectmap: FindObjectMap,
  faq: FAQ,
  headinfo: Headinfo,
  schankdruckrechner: Schankdruckrechner,
  brandsheader: BrandsHeader,
  brandsimgtext: BrandsImgText,
  imageslider: ImageSlider,
  brandsoverview: BrandsOverview,
  productslider: ProductSlider,
  serviceheadinfo: ServiceHeadinfo,
  serviceshorttext: ServiceShortText,
  serviceslider: ServiceSlider,
  schankdruckrechner: Schankdruckrechner,
  contact: Contact,
  servicemap: ServiceMap,
  servicecontactperson: ServiceContactPerson,
  servicesinglebutton: ServiceSingleButton,
  servicemysterycheck: ServiceMysterycheck,
  seminarangebot: Seminarangebot,
  seminarangebotoffering: SeminarangebotOffering,
  productsliderwrap: ProductSliderWrap,
  listitem: ListItem,
  items: Item,
  imagesliderwrap: ImageSliderWrap,
  faqwrap: FAQWrap,
  instagramsliderwrap: InstagramSliderWrap,
  instagramslider: InstagramSlider,
  soloimage: SoloImage,
  textimage: TextImage,
  brandslogoslider: BrandsLogoSlider,
  infotextimage: InfotextImage,
  intrologo: IntroLogo,
  imageinfotext: ImageInfotext,
  richtext: RichText,
  singleimagebig: SingleImageBig,
  singleimagesmall: SingleImageSmall,
  schanktechnikcontent: SchanktechnikContent,
  servicetextsmallimage: ServiceTextSmallImage,
  headlinewithtext: HeadlineWithText,
  headlinewithrichtext: HeadlineWithRichtext,
  headlinefooter: HeadlineFooter,
  singletext: SingleText,
  seminartextcolumn: SeminarTextColumn,
  servicesubheadline: ServiceSubheadline,
  serviceimagetext: ServiceImgText,
  textwithsections: TextWithSections,
  imagefullwidth: ImageFullWidth,
  textbuttonimage: TextButtonImage,
  servicetextfiftyfifty: ServiceTextFiftyFifty,
  servicebigtextonly: ServiceBigTextOnly,
  cookielayerlink: CookieLayerLink,
  brandsheaderbiglogos: BrandsHeaderBigLogos,
  textimagesmaller: TextImageSmaller,
  brandsheaderhacker: BrandsHeaderHacker,
  brandsheaderpaulaner: BrandsHeaderPaulaner,
  gastroforumbigpicture: GastroforumBigPicture,
  servicesinglebuttonsmaller: ServiceSingleButtonSmaller,
  brandsheaderhopf: BrandsHeaderHopf,
  headlineandbutton: HeadlineAndButton,
  seminarheadlineandbutton: SeminarHeadlineAndButton,
  textwithbutton: TextWithButton,
  textwithbuttonintro: TextWithButtonIntro,
  imgtextarticle: ImgTextArticle,
  imgtextleft: ImgTextLeft,
  iconswithbutton: IconsWithButton,
  textwithcontact: TextWithContact,
  imgtextbutton: ImgTextButton,
  brandslogos: BrandsLogos,

};

if (process.env.NODE_ENV === "production" && typeof window !== "undefined") {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
  console.warn = () => {};
  console.error = () => {};
}

storyblokInit({
  accessToken: process.env.STORYBLOK_TOKEN ?? "---",
  bridge: process.env.STORYBLOK_TOKEN ? true : false,
  use: [apiPlugin],
  components,
});

function MyApp({ Component, pageProps }) {
  const { key, ...rest } = pageProps;
  const router = useRouter();
  const pathParts = router.asPath.split("/").filter((part) => part !== ""); // Pfad in ein Array von Strings aufteilen und leere Elemente entfernen
  let formattedPathName = "";
  let pageTitle = "";
  const [showCookies, setShowCookies] = useState("");
  
  /* console.log(pathParts.length, pathParts[0]); */

  if (pathParts.length == 1 && pathParts[0] == "marken-und-biere") {
    formattedPathName = "Marken und Biere";
  } else if (pathParts.length == 1 && pathParts[0] == "service-und-seminare") {
    formattedPathName = "Service und Seminare";
  } else if (
    pathParts.length == 1 &&
    pathParts[0] == "schanktechnik-und-bierpflege"
  ) {
    formattedPathName = "Schanktechnik und Bierpflege";
  }else if(pathParts.length == 1 &&
    pathParts[0].includes("?")){
      formattedPathName = "";
  } else {
    const pathName = pathParts[pathParts.length - 1];
    formattedPathName = pathName
      ? pathName.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())
      : "";
    if (formattedPathName === "Auerbraeu") {
      formattedPathName = "Auerbräu";
    }
    if (formattedPathName === "Fuerstenberg") {
      formattedPathName = "Fürstenberg";
    }
    if (formattedPathName === "Pachtboerse") {
      formattedPathName = "Pachtbörse";
    }
  }

    if(!formattedPathName.includes("?")){
      pageTitle = formattedPathName
      ? `${formattedPathName} | Erfolgreichgastro`
      : "Erfolgreichgastro";
    /* console.log(pageTitle); */
    }else{
      pageTitle = "Erfolgreichgastro";
    /* console.log(pageTitle); */
    }


  //COOKIES
  let gTag = "https://www.googletagmanager.com/gtag/js?id=G-2XWKVJ3TQS";

  let gTag2 = `
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());
  gtag('config', 'https://www.googletagmanager.com/gtag/js?id=G-2XWKVJ3TQS');
`;

  //const [cookies] = useCookies(["cookieConsent", "ageCheck"]);
  //const hasCookieConsent = cookies.cookieConsent === "true";
  //const hasAgeCheck = cookies.ageCheck === "true";

/* 
    useEffect(() => {
      // Die aktuelle URL abrufen
      const currentURL = window.location.href;
  
      // Das zu filternde Wort oder Muster
      const markenUndBiere = 'markenundbiere/';
      const serviceUndSeminare = 'serviceundseminare/';
      const schanktechnikUndBierpflege = 'schanktechnikundbierpflege/';
      const unternehmen = 'unternehmen/';
  
      // Überprüfen, ob das Filterwort in der URL vorhanden ist
      if (currentURL.includes(markenUndBiere)) {
        // Das Filterwort aus der URL entfernen und die URL aktualisieren
        const newURL = currentURL.replace(markenUndBiere, '');
         window.history.replaceState(null, null, newURL);
      }else if(currentURL.includes(serviceUndSeminare)){
        const newURL = currentURL.replace(serviceUndSeminare, '');
         window.history.replaceState(null, null, newURL);
      }else if(currentURL.includes(schanktechnikUndBierpflege)){
        const newURL = currentURL.replace(schanktechnikUndBierpflege, '');
         window.history.replaceState(null, null, newURL);
      }else if(currentURL.includes(unternehmen)){
        const newURL = currentURL.replace(unternehmen, '');
         window.history.replaceState(null, null, newURL);
      }
      }); */

  return (
    <div className="main-page">
      <Head>
        <title>{pageTitle}</title>
        <link rel="icon" href="../src/favicon-hpeg/favicon.ico" />
        <link rel="icon" href="../src/favicon-hpeg/favicon-16x16.png"></link>
        <link rel="apple-touch-icon" sizes="180x180" href="../src/favicon-hpeg/favicon.png" />
        <link rel="apple-touch-icon" href="../src/favicon-hpeg/favicon_32.png" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta charSet="UTF-8" />
        <meta name="description" content="Erfolgreichgastro" />
        <meta name="title" content="Erfolgreichgastro" />
        <meta name="keywords" content="Erfolgreichgastro" />
        <meta name="google-site-verification" content="JCPYV1RGWFWI8dim28ZYBPSP6TJX-dGS1YbejxAEIdk" />
      </Head>

      <CookiesProvider>
        <AgeCheck />
        <CookieConsent/>
        <Component key={key} {...rest}/>
      </CookiesProvider>
      <Script src="/formio.js" strategy="beforeInteractive" />
      <Script dangerouslySetInnerHTML={{ __html: `<!--Datenwerk GmbH - http://www.datenwerk.de -->` }} />
    </div>
  );
}

export default MyApp;
